<template>
    <div class="overflow-y-scroll">
        <div class="code-header px-4 py-2 text-gray-400 text-sm tracking-wide">
            {{  title  }}
        </div>
        <div class="overflow-y-scroll" style="max-height: 600px;">
          <highlightjs :language='lang' :code="fixedCode" />
        </div>
    </div>
  </template>
  
  <script>
//   import 'highlight.js/lib/common';
  import hljsVuePlugin from "@highlightjs/vue-plugin";
  
  export default {
    name: "CodeBlock",
    data: () => {
      
    },
    props: ["code", "lang", "title"],
    mounted () {
      
    },
    computed: {
        fixedCode () {
            if (this.lang === "json") {
                return JSON.stringify(this.code, null, 2)
            }

            return this.code
        }
    },
    methods: {
     
    },
    components: {
        highlightjs: hljsVuePlugin.component
    }
    
  }
  </script>
  